/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Pavel Bobylev <pavel.bobylev1988@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {TemplateFeature} from './TemplateFeature';

export interface TemplateFeatureGroup {
  id?: number;
  header: string;
  templateId?: number;
  groupId: number;
  uid?: string;
  features?: TemplateFeature[];
  hilight?: boolean;
  sort?: number;
  /** PIM2-637 — общая группа: приходит с самим payload'ом шаблона, отдельного запроса не требует. */
  isCommon?: boolean;
}
